<template>
  <MainLayout>
    <div class="ActivityLunch">
      <!--<div class="activityContainer">
        <div class="contact">
          <p>{{$t('global.咨询赛事与商务合作，请直接拨打我们的电话或者填写表单，我们将在第一时间响应。')}}</p>
          {{$t('global.联系人')}}：Lizki
          <br />
          {{$t('global.手机号')}}：18701836024
          <br />
          {{$t('global.座机号')}}：021-52998050
          <br />
          {{$t('global.邮 箱')}}：liz.li@manamana.net
          <br />
        </div>
      </div>-->
      <el-form ref="form" :rules="rules" :model="form" :label-position="labelPosition">
        <div class="activityContainer" id="view1">
          <el-form-item prop="title" :label="$t('global.活动标题')">
            <el-input type="text" :placeholder="$t('global.请输入活动标题')" v-model="form.title"></el-input>
          </el-form-item>
          <el-form-item prop="industryId" :label="$t('global.行业')">
            <el-checkbox-group v-model="form.industryId">
              <el-checkbox
                v-for="(item,index) in industryList"
                :key="index"
                :label="item.categoryId"
              >{{item.title}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item prop="professionId" :label="$t('global.专业')">
            <el-checkbox-group v-model="form.professionId">
              <el-checkbox
                v-for="(item,index) in professionList"
                :key="index"
                :label="item.categoryId"
              >{{item.title}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item :label="$t('global.活动报名时间')" required  prop="signDate" id="view3">
            <el-col :span="10">
              <el-form-item prop="signDate">
                <el-date-picker
                  v-model="form.signDate"
                  type="daterange"
                  :range-separator="$t('global.至')"
                  :start-placeholder="$t('global.开始日期')"
                  :end-placeholder="$t('global.结束日期')"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item :label="$t('global.活动举办时间')" required  prop="holdDate" id="view4">
            <el-col :span="10">
              <el-form-item prop="holdDate">
                <el-date-picker
                  v-model="form.holdDate"
                  type="daterange"
                  :range-separator="$t('global.至')"
                  :start-placeholder="$t('global.开始日期')"
                  :end-placeholder="$t('global.结束日期')"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
          <div class="buyTicks">
            <span>{{$t('global.购票链接')}}</span>
            <input type="text" v-model="tickLink" :placeholder="$t('global.请输入购票链接')" />
          </div>
        </div>
        <div class="activityContainer uploadContainer" id="view2">
          <el-form-item prop="cover">
            <span class="font"><i>*</i>{{$t('global.活动封面')}}</span>
            <span class="limit">{{$t('global.上传图片请控制在3M以内')}},{{$t('global.上传图片比例为')}}3:4</span>
            <div class="bline"></div>
            <el-upload
              class="thumb-uploader"
              action="/api/common/upload/image"
              name="files"
              accept="image/*"
              :show-file-list="false"
              :before-upload="beforeCoverUpload"
              :on-success="handleCoverSuccess"
            >
              <img v-if="form.cover" :src="form.cover | imageUrl('',360,480)" class="thumb" />
              <i v-else class="cover-uploader-icon">{{$t('global.请上传活动封面')}}</i>
              <el-button size="small" type="primary">{{$t('global.修改')}}</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item :required="false">
            <span class="font">{{$t('global.活动图片')}}</span>
            <span class="limit">{{$t('global.上传图片请控制在3M以内')}}，{{$t('global.上传图片个数最大为12')}}</span>
            <div class="bline"></div>
            <el-upload
              class="thumb-uploader"
              ref="uploadimgs"
              action="/api/common/upload/image"
              name="files"
              multiple
              accept="image/*"
              list-type="picture-card"
              :on-exceed="handleExceed"
              :on-remove="handleRemove"
              :before-upload="beforeThumbUpload"
              :on-success="handleThumbSuccess"
              :file-list="back_fileList"
            >
              <i class="thumb-uploader-icon">{{$t('global.请上传活动图片')}}</i>
              <el-button size="small" type="primary">{{$t('global.修改')}}</el-button>
            </el-upload>
          </el-form-item>
        </div>
        <div class="activityContainer">
          <span class="font">{{$t('global.活动介绍')}}</span>
          <tinymc-editor :content="tinymceHtml" @changeEdit="changeEdit" />
        </div>
        <div class="button-wrap">
          <el-button class="confirm button" @click="submit">{{$t('global.提交')}}</el-button>
        </div>
      </el-form>
    </div>
  </MainLayout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout";
import CheckboxGroup from "@/components/widgets/CheckboxGroup";
import tinymcEditor from "@/components/editor/Editor";
import { formatDate, imageUrl } from "@/util/filters.js";

export default {
  name: "ActivityLunch",
  metaInfo() {
    return {
      title: this.$t("global.发起活动-竞赛") + " | MANA"
    };
  },
  components: {
    CheckboxGroup,
    MainLayout,
    tinymcEditor
  },
  model: {
    prop: "toggleForm",
    event: "toggleForm"
  },
  props: {
    toggleForm: Boolean
  },
  data() {
    var checkHold = (rule, value, callback) => {
      callback();
    };
    var checkSign = (rule, value, callback) => {
      callback();
    };
    return {
      config: {
        initialFrameHeight: 350
      },
      defaultMsg: "",
      labelPosition: "top",
      form: {
        title: "",
        signDate: [],
        holdDate: [],
        cover: "",
        thumb: [],
        content: "",
        industryId: [],
        professionId: []
      },
      tickLink: "",
      industryList: [],
      professionList: [],
      imgList: [],
      scale: [],
      imgUrl: "",
      isHidden: true,
      rules: {
        title: [
          {
            required: true,
            message: this.$t("global.活动标题不能为空"),
            trigger: "blur"
          }
        ],
        signDate: [
          {
            required: true,
            message: this.$t("global.请选择报名时间"),
            trigger: "blur"
          },
          { validator: checkSign, trigger: "change" }
        ],
        holdDate: [
          {
            required: true,
            message: this.$t("global.请选择举办时间"),
            trigger: "blur"
          },
          { validator: checkHold, trigger: "change" }
        ],
        professionId: [
          {
            required: true,
            message: this.$t("global.请选择专业"),
            trigger: "blur"
          }
        ],
        industryId: [
          {
            required: true,
            message: this.$t("global.请选择行业"),
            trigger: "blur"
          }
        ],
        cover: [
          {
            required: true,
            message: this.$t("global.请上传图片封面"),
            trigger: "change"
          }
        ]
      },
      activityId: null,
      backFileData: "",
      back_fileList: [],
      tinymceHtml: this.$t("global.请输入")
    };
  },
  computed: {
    localTime() {
      var date = new Date();
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      return y + "-" + m + "-" + d;
    }
  },
  created() {
    this.init();
  },
  mounted() {},
  destroyed() {},
  methods: {
    init() {
      this.categoryList();
      if (this.$route.query.activityId) {
        this.activityId = this.$route.query.activityId;
        document.title = `${this.$t("global.编辑活动")} | MANA`;
        this.$http
          .get("/api/activity/detail", {
            params: {
              activityId: this.activityId
            }
          })
          .then(data => {
            this.backFile_fn(data.data);
          });
      }
    },
    changeEdit(content) {
      this.tinymceHtml = content;
    },
    backFile_fn(data) {
      const _this = this;
      //$t('global.活动标题')
      this.form.title = data.title;
      //$t('global.行业')
      for (let i = 0; i < data.industryList.length; i++) {
        const el = data.industryList[i];
        this.form.industryId.push(el.id);
      }
      //$t('global.专业')
      for (let i = 0; i < data.professionList.length; i++) {
        const el = data.professionList[i];
        this.form.professionId.push(el.id);
      }
      //$t('global.活动报名时间')
      this.form.signDate = [
        formatDate(data.signStartTime).split(" ")[0],
        formatDate(data.signEndTime).split(" ")[0]
      ];
      //$t('global.活动举办时间')
      this.form.holdDate = [
        formatDate(data.holdStartTime).split(" ")[0],
        formatDate(data.holdEndTime).split(" ")[0]
      ];
      //$t('global.活动封面')
      this.form.cover = data.thumb;
      //$t('global.活动图片')
      for (let i = 0; i < data.imageList.length; i++) {
        const el = data.imageList[i];
        const Obj = {
          name: "img-" + i,
          url: imageUrl(el)
        };
        this.back_fileList.push(Obj);
        this.form.thumb.push(imageUrl(el));
      }
      //$t('global.活动介绍')
      this.tinymceHtml = data.introduction;
    },
    randomString() {
      var len = 2;
      var $chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
      var maxPos = $chars.length;
      var pwd = "";
      for (let i = 0; i < len; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    categoryList() {
      this.$http.get("/api/common/categoryList").then(response => {
        this.industryList = response.data.industryList;
        this.professionList = response.data.professionList;
      });
    },
    handleRemove(file, fileList) {
      const thumb = [];
      for (let i = 0; i < fileList.length; i++) {
        const el = fileList[i];
        thumb.push(el.url);
      }
      this.form.thumb = thumb;
    },
    handleExceed() {
      this.$message.error(this.$t("global.超出图片上传个数限制"));
    },
    beforeCoverUpload(file, fileList) {
      let isLt3M = file.size / 1024 / 1024 < 3;
      if (!isLt3M) {
        this.$message.error(`${this.$t("global.上传图片大小不能超过")} 3MB!`);
        return false;
      }
      // this.loading = this.$loading({
      //   lock: true,
      //   text: "Loading",
      //   spinner: "el-icon-loading",
      //   background: "rgba(0, 0, 0, 0.7)"
      // });
    },
    beforeThumbUpload(file) {
      let isLt3M = file.size / 1024 / 1024 < 3;
      if (!isLt3M) {
        this.$message.error(`${this.$t("global.上传图片大小不能超过")} 3MB!`);
        return false;
      }
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.imgUrl =
        "/api/common/upload/image?" +
        this.randomString() +
        "=" +
        this.randomString();
    },
    back_imgList(file) {
      console.log(file);
    },
    handleCoverSuccess(res, file) {
      if (this.loading) this.loading.close();
      this.form.cover = res.data;
      this.$message.success(this.$t("global.上传图片成功"));
    },
    handleThumbSuccess(res, file) {
      if (this.loading) {
        this.loading.close();
      }
      if (res.code === "OK") {
        this.form.thumb.push(imageUrl(res.data));
      }
    },
    submit() {
      var $this = this;
      let postUrl = "";
      if (!this.form.title.replace(/[\r\n\s]/g, "")) {
        this.$message({
          message: this.$t("global.活动标题不能为空"),
          type: "error",
          duration: 2000
        });
        document.getElementById("view1").scrollIntoView(true);
        return;
      }
      if (!this.form.industryId.length) {
        this.$message({
          message: this.$t("global.请选择行业"),
          type: "error",
          duration: 2000
        });
        document.getElementById("view1").scrollIntoView(true);
        return;
      }
      if (!this.form.professionId.length) {
        this.$message({
          message: this.$t("global.请选择专业"),
          type: "error",
          duration: 2000
        });
        document.getElementById("view1").scrollIntoView(true);
        return;
      }
      if (!this.form.signDate.length) {
        this.$message({
          message: this.$t("global.请选择报名时间"),
          type: "error",
          duration: 2000
        });
        document.getElementById("view3").scrollIntoView(true);
        return;
      }
      if (!this.form.holdDate.length) {
        this.$message({
          message: this.$t("global.请选择举办时间"),
          type: "error",
          duration: 2000
        });
        document.getElementById("view4").scrollIntoView(true);
        return;
      }
      if (this.form.signDate[1] > this.form.holdDate[1]) {
        this.$message({
          message: this.$t("global.报名结束时间不可晚于举办结束时间"),
          type: "error",
          duration: 2000
        });
        document.getElementById("view3").scrollIntoView(true);
        return;
      }
      const reg = /^http(s?):\/\//;
      if (this.tickLink && !reg.test(this.tickLink)) {
        this.$message({
          message: this.$t("works.链接应以http://或 https://开头"),
          type: "error",
          duration: 2000
        });
        document.getElementById("view3").scrollIntoView(true);
        return;
      }
      if (!this.form.cover) {
        this.$message({
          message: this.$t("global.请上传活动封面"),
          type: "error",
          duration: 2000
        });
        document.getElementById("view2").scrollIntoView(true);
        return;
      }
      const param = {
        category: 1,
        images: this.form.thumb,
        industryId: this.form.industryId,
        professionId: this.form.professionId,
        title: this.form.title,
        thumb: this.form.cover,
        signStartTime: this.form.signDate[0],
        signEndTime: this.form.signDate[1],
        introduction: this.tinymceHtml,
        holdStartTime: this.form.holdDate[0],
        holdEndTime: this.form.holdDate[1],
        purchaseLink: this.tickLink
      };
      if (this.activityId) {
        postUrl = "/api/u/activity/update";
        param.id = this.activityId;
      } else {
        postUrl = "/api/u/activity/apply";
      }
      this.$http.post(postUrl, param).then(response => {
        if (response.code === "OK") {
          this.$message({
            message: this.$t("global.提交成功"),
            type: "success",
            duration: 2000
          });
          //$t('global.保存后清空内容')
          if (this.activityId) {
            this.$router.push(`/activity/${this.activityId}/detail`);
          } else {
            this.$router.push("/activity/all");
          }
        } else {
          this.$message({
            message: response.message,
            type: "error",
            duration: 2000
          });
        }
      });
    }
  }
};
</script>
<style lang="stylus" scoped>
#view3,#view4{
  padding-top: 66px;
  margin-top: -66px;
}
.activityContainer >>> .el-form-item__label {
  padding: 0 0 6px;
  font-size: 0.24rem;
  color: #000;
}

.activityContainer >>> .el-radio__label {
  font-size: 0.18rem;
  font-family: initial;
  color: #999;
}

.activityContainer >>> .el-radio__inner {
  border: 2px solid #dcdfe6;
  width: 16px;
  height: 16px;
}

.activityContainer >>> .el-checkbox__label {
  font-size: 0.18rem;
  font-family: initial;
  color: #999;
}

.activityContainer >>> .el-checkbox__inner {
  width: 16px;
  height: 16px;
}

.activityContainer >>> .el-upload-list--picture-card .el-upload-list__item {
  width: 3.6rem;
  height: 2rem;
  margin-top: 0.1rem;
}

.activityContainer >>> .el-button--small, .el-button--small.is-round {
  display: block;
  margin: 0.4rem 0 0.2rem 1rem;
  border-radius: 1rem;
  background: #0060ff;
  width: 1.6rem;
  line-height: 0.34rem;
  font-size: 0.21rem;
}

.activityContainer >>> .el-input__inner {
  width: 100%;
  height: 40px;
  margin-top: 0;
}

.activityContainer {
  background: #fff;
  width: 19.5rem;
  margin: -0.16rem auto 0;
  padding: 1.28rem 3.7rem 0.62rem;
  box-sizing: border-box;
}

.uploadContainer {
  padding: 0.62rem 3.7rem 2rem;
}

.ActivityLunch {
  .contact {
    color: #000;
    font-size: 0.18rem;
    letter-spacing: 1px;
    line-height: 0.35rem;
    font-family: initial;

    p {
      margin-bottom: 0.24rem;
    }
  }

  .el-form-item {
    color: #000;

    .el-radio {
      color: #777;
      line-height: 3;
      margin-right: 30px;
    }

    .el-radio + .el-radio {
      margin-left: 0;
    }

    .el-checkbox {
      width: 1.5rem;
      margin-right: 30px;
    }

    .el-checkbox + .el-checkbox {
      margin-left: 0;
    }

    .dateLine {
      text-align: center;
    }
  }

  .button-wrap {
    display: flex;
    justify-content: space-between;
    padding-bottom: 0.4rem;

    .button {
      width: 2.5rem;
      height: 0.64rem;
      // line-height: 0.68rem;
      text-align: center;
      margin: 0 auto;
      border-radius: 0.9rem;
      font-size: 0.24rem;
    }

    .confirm {
      background-color: #0060ff;
      color: #ffffff;
    }

    .cancle {
      background-color: #eee;
      color: #999999;
    }
  }

  .font {
    font-size: 0.24rem;
    color: #000;
    margin-bottom: 0.2rem;
    display: inline-block;
    i{
      color: #F56C6C;
      margin-right: 4px;
    }
  }

  .limit {
    font-size: 0.18rem;
    color: #777;
    margin-left: 0.2rem;
  }

  .bline {
    width: 100%;
    height: 0.02rem;
    background: #dcdfe6;
    margin: 0.2rem 0 0.45rem;
  }

  .editorContent {
    margin-top: 0.4rem;
  }

  .ActivityLunch {
    position: absolute;
    z-index: 9;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    opacity: 0.7;
  }

  .thumb {
    // width: 3.8rem;
    height: 2.1rem;
  }

  .thumb-uploader-icon, .cover-uploader-icon {
    display: block;
    width: 3.8rem;
    height: 5.1rem;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    border-radius: 6px;
    position: relative;
    background: url('/static/explore/add.png') no-repeat center center #fff;
    -webkit-background-size: 0.8rem 0.8rem;
    background-size: 0.8rem 0.8rem;
    font-size: 0.22rem;
    color: #333333;
    text-align: center;
    padding-top: 1.6rem;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    border: 1px solid #fdfdfd;
    -webkit-box-shadow: 0 2px 5px rgba(0, 0, 0, 0.8);
    -moz-box-shadow: 0 2px 5px rgba(0, 0, 0, 0.8);
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.8);
  }

  .thumb-uploader-icon {
    height: 2.1rem;
    padding-top: 0.8rem;
  }
}

.el-form-item >>> .el-upload--picture-card {
  line-height: 1.8rem;
  border: none;
}

@keyframes rotate {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(180deg);
  }
}

@keyframes rotate-reverse {
  from {
    transform: rotate(180deg);
  }

  to {
    transform: rotate(0);
  }
}
</style>
<style>
.thumb-uploader .el-upload-list__item .el-upload-list__item-thumbnail {
  height: auto;
}
.activityContainer .el-form-item__content {
  height: auto !important;
}
.buyTicks span {
  display: block;
  font-size: 0.24rem;
  color: #000;
}
.buyTicks input {
  width: 45.83333%;
  height: 40px;
  border-radius: 4px;
  padding: 0 15px;
  margin-top: 15px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  background-color: #fff;
}
.buyTicks input::-webkit-input-placeholder {
  color: #c0c4cc;
  font-size: 14px;
}

.buyTicks input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #c0c4cc;
  font-size: 14px;
}

.buyTicks input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #c0c4cc;
  font-size: 14px;
}

.buyTicks input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #c0c4cc;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/ActivityLunch.vue